import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

import SvgIcon from '../internal/SvgIcon/SvgIcon'

export default class IconFactory {
  static create(path: string, label: string, name: string) {
    return Vue.extend({
      name,
      functional: true,
      render(h, { data }) {
        return h(SvgIcon, mergeData(data, { props: { path, label } }))
      },
    })
  }
}
